// @ts-check

import React from 'react';
import { bool, func, object, string } from 'prop-types';
import TextField from '@mui/material/TextField';
import USER from '../ts/profileEditorEnum';

/**
 * @component ProfileEditorField
 * @param {Object} props
 * @param {string} props.name
 * @param {boolean} props.required
 * @param {string} props.label
 * @param {string} props.value
 * @param {EditorValidType|undefined} [props.valid]
 * @param {(name:string, payload:any) => void} props.onHandleUser
 * @returns {JSX.Element}
 */
function ProfileEditorField({ name, required, label, value, valid, onHandleUser }) {
	return (
		<TextField
			name={name}
			color="primary"
			size={name === USER.UNIT ? 'medium' : 'small'}
			fullWidth
			variant="outlined"
			InputLabelProps={{ shrink: true }}
			required={required}
			label={label}
			value={value}
			error={valid?.hasErr}
			helperText={valid?.msg}
			onChange={(e) => onHandleUser(e.target.name, e.target.value)}
		/>
	);
}

ProfileEditorField.propTypes = {
	name: string,
	required: bool,
	label: string,
	value: string,
	valid: object,
	onHandleUser: func,
};

export default ProfileEditorField;
